// src/components/WasteTransferNote.js
import React from 'react';
import BrandName from './BrandName';
import RegisterCheck from './RegisterCheck';
import { licenceForPaperwork } from '../utils/jobPrivacy';
import './WasteTransferNote.css';

const NOT_PROVIDED = 'Not provided';

const firstText = (...values) => {
  for (const value of values) {
    const text = String(value ?? '').trim();
    if (text) return text;
  }
  return '';
};

const WasteTransferNote = ({ job, carrier, wtnRef }) => {
  const ref = wtnRef || job?.wtnRef || '—';
  const date = new Date().toLocaleDateString('en-GB');
  const licence = licenceForPaperwork(carrier?.licenceNo);
  const pickup = firstText(job?.pickupAddress, job?.location, job?.pickup);
  const dropoff = firstText(job?.dropoffAddress, job?.dropoff);
  const company = firstText(carrier?.providerName, carrier?.name);
  const description = firstText(job?.description);

  return (
    <div className="wtn-card">
      <div className="wtn-header">
        <div>
          <div className="wtn-logo"><BrandName /></div>
          <div className="wtn-subtitle">Waste Transfer Note</div>
        </div>
        <div className="wtn-ref">
          <div className="wtn-ref-label">Reference</div>
          <div className="wtn-ref-val">{ref}</div>
          <div className="wtn-ref-label" style={{marginTop:'4px'}}>Date</div>
          <div className="wtn-ref-val">{date}</div>
        </div>
      </div>

      <div className="wtn-body">
        <div className="wtn-section">
          <div className="wtn-section-title">Waste Producer</div>
          <div className="wtn-row"><span>Pickup Address:</span><span>{pickup || NOT_PROVIDED}</span></div>
          {dropoff && (
            <div className="wtn-row"><span>Drop-off Address:</span><span>{dropoff}</span></div>
          )}
          <div className="wtn-row"><span>Description:</span><span>{description || NOT_PROVIDED}</span></div>
          <div className="wtn-row"><span>Service:</span><span>{firstText(job?.serviceType) || NOT_PROVIDED}</span></div>
        </div>

        <div className="wtn-section">
          <div className="wtn-section-title">Waste carrier</div>
          <div className="wtn-row"><span>Company:</span><span>{company || NOT_PROVIDED}</span></div>
          <div className="wtn-row">
            <span>Licence number:</span>
            <span className={licence ? 'wtn-licence' : 'wtn-missing'}>{licence || NOT_PROVIDED}</span>
          </div>
          {!licence && (
            <p className="wtn-prompt">
              This note is incomplete until the carrier adds their waste carrier licence number.
              Carriers: email info@thewastegame.co.uk and we will add it to your profile.{' '}
              <RegisterCheck />
            </p>
          )}
        </div>

        {licence ? (
        <div className="wtn-compliance">
          <div className="wtn-compliance-icon">✅</div>
          <div>
            <div className="wtn-compliance-title">Keep this record</div>
            <div className="wtn-compliance-text">
              This note records the details above. It does not guarantee the waste was handled legally.
              Check the registration yourself and keep the note with your records.
            </div>
          </div>
        </div>
        ) : (
        <div className="wtn-compliance wtn-compliance-warn">
          <div className="wtn-compliance-icon">⚠️</div>
          <div>
            <div className="wtn-compliance-title">Licence number missing</div>
            <div className="wtn-compliance-text">
              This note cannot confirm the carrier&apos;s registration until a real licence number is recorded.{' '}
              <RegisterCheck />
            </div>
          </div>
        </div>
        )}
      </div>

      <div className="wtn-footer">
        <button className="btn btn-outline btn-sm" onClick={() => window.print()}>🖨 Print / Save PDF</button>
        <span className="wtn-legal">
          {licence
            ? <RegisterCheck />
            : 'Incomplete — add the carrier licence number before relying on this note'}
        </span>
      </div>
    </div>
  );
};

export default WasteTransferNote;
